<template>
  <div class="app flex-row align-items-center">
    <nprogress-container style="height: 3px !important; z-index: 9999;"></nprogress-container>
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-6 col-lg-5 col-12">
          <div class="col-12 text-center p-4" style="border: none; background: #EAEAEAAA;border: 1px solid #c2cfd6;border-bottom: none">
            <img src="/static/img/logo.png" style="max-height: 50px"/>
          </div>
          <div class="card-group mb-0">
            <div class="card p-4">
              <div class="card-body">
                <h3>Infia Commerce</h3>
                <p class="text-muted">Sign In to your account</p>
                <div class="alert alert-warning b-t-20" v-if="isError">
                  <i class="fa fa-exclamation-circle"></i>&nbsp;Username or Password is Invalid
                </div>
                <div class="input-group mb-3">
                  <span class="input-group-addon"><i class="icon-user"></i></span>
                  <input type="text" class="form-control" placeholder="Username" v-bind:class="{ 'error': usernameError  }" v-model="username">
                </div>
                <div class="input-group mb-4">
                  <span class="input-group-addon"><i class="icon-lock"></i></span>
                  <input type="password" class="form-control" placeholder="Password" v-bind:class="{ 'error': passwordError  }" v-model="password">
                </div>
                <div class="row">
                  <div class="col-6">
                    <button type="button" class="btn btn-primary px-4" v-on:click="doLogin">Login</button>
                  </div>
                  <!-- <div class="col-6 text-right">
                    <button type="button" class="btn btn-link px-0">Forgot password?</button>
                  </div> -->
                </div>
              </div>
            </div>
            <!-- <div class="card text-white bg-primary py-5 d-md-down-none" style="width:44%">
              <div class="card-body text-center">
                <div>
                  <h2>Sign up</h2>
                  <p>
                    Infia Commerce is a software-as-a-service (SaaS) platform used mainly to manage your sales logs and inventory.
                  </p>
                  <button type="button" class="btn btn-primary active mt-3">Contact Us to Register!</button>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NprogressContainer from 'vue-nprogress/src/NprogressContainer'

export default {
  data () {
    return {
      username: '',
      password: '',
      usernameError: false,
      passwordError: false,
      isError: false
    }
  },
  metaInfo () {
    return {
      title: 'Infia Commerce - An Integrated Sales Management'
    }
  },
  components: {
    NprogressContainer
  },
  methods: {
    doLogin () {
      if (this.username.length > 0 && this.password.length > 0) {
        this.usernameError = false
        this.passwordError = false

        // do actual login here
        var data = new URLSearchParams()
        data.append('grant_type', 'password')
        data.append('username', this.username)
        data.append('password', this.password)

        var vm = this
        this.axios.post('oauth2/token/', data)
          .then(
            (response) => {
              vm.isError = false
              console.log(response)
              var token = JSON.stringify(response.data)
              localStorage.setItem('token', token)
              vm.axios.get('api/user/account/' + encodeURIComponent(vm.username) + '/?type=username')
                .then(
                  (response) => {
                    var account = JSON.stringify(response.data)
                    localStorage.setItem('account', account)
                    vm.$router.push('/')
                  }
                )
                .catch(
                  (error) => {
                    console.log(error)
                    localStorage.clear()
                    vm.isError = true
                  }
                )
            }
          )
          .catch(
            (error) => {
              console.log(error)
              vm.isError = true
            }
          )
      } else {
        if (this.username.length === 0) {
          this.usernameError = true
        }
        if (this.password.length === 0) {
          this.passwordError = true
        }
      }
    }
  }
}
</script>

<style scoped>
  .form-control.error {
    border: solid 1px red;
  }

  .app {
    background-image: url('/static/img/bg.jpg');
    background-repeat: no-repeat;
    background-size: 'cover';
    
  }
</style>



// WEBPACK FOOTER //
// src/views/Login.vue